export default __webpack_public_path__ + "static/media/flag-slovakia.e8477855.svg";